import httpCreater from '@yld/yun-utils-http-creater'
import { Cookie } from '@yld/yun-utils-common'
import { Message } from 'element-ui'
import {
  configureErrorMessage,
  resetErrorMessageConfig,
  resolveErrorMessage
} from '@yld/yun-utils-http/error-message'

const DEFAULT_LANG_CODE = 'zh_CN'

const http = httpCreater({
  javaHeader: {
    get xLangCode() {
      return Cookie.getCookie('_xLang_code', null, false) || DEFAULT_LANG_CODE
    }
  },
  onFailrue: res => {
    Message({
      message: resolveErrorMessage(res),
      type: 'error',
      duration: 5 * 1000
    })
    return res
  }
})

export {
  configureErrorMessage,
  resetErrorMessageConfig,
  resolveErrorMessage
}

export default http
